import VideoModal from './VideoModal'

export default VideoModal
